export const SET_EVENTS = 'SET_EVENTS'
export const SET_MONTH = 'SET_MONTH'
